import { z } from 'zod';
/**
 * Money and ratio primitives.
 *
 * Prices cross the wire as `number`. They are stored as DECIMAL in MySQL so that
 * the database never performs lossy float arithmetic; conversion happens in exactly
 * one place (`apps/api/src/db/converters.ts`).
 */
/** A tradable price: finite, non-negative. */
export const priceSchema = z.number().finite().nonnegative();
/** A price that must be strictly positive (e.g. a stop-loss level). */
export const positivePriceSchema = z.number().finite().positive();
/** A percentage expressed as a human value, e.g. `7.5` means 7.5 %. */
export const percentSchema = z.number().finite();
/** A percentage constrained to 0..100. */
export const boundedPercentSchema = z.number().finite().min(0).max(100);
/** Traded volume. Some providers omit it, so it is nullable throughout. */
export const volumeSchema = z.number().finite().nonnegative().nullable();
/** Number of decimal places used when persisting prices. */
export const PRICE_SCALE = 6;
/** Rounds to the persisted precision so comparisons stay stable across layers. */
export const roundPrice = (value) => Math.round(value * 10 ** PRICE_SCALE) / 10 ** PRICE_SCALE;
//# sourceMappingURL=numeric.js.map